import MainLayout from "../../layouts/MainLayout";
import Hero from "../../components/Hero/Hero";
import IndustryPicker from "../../components/IndustryPicker/IndustryPicker";
import VirtualEmployeesSection from "../../components/VirtualEmployeesSection/VirtualEmployeesSection";
import HireModalProvider from "../../components/HireModal/HireModalProvider";
import FeaturedCases from "../../components/FeaturedCases/FeaturedCases";
import SoftwareFactorySection from "../../components/SoftwareFactorySection/SoftwareFactorySection";
import EcommerceSection from "../../components/EcommerceSection/EcommerceSection";
import AISection from "../../components/AISection/AISection";
import EnterpriseBand from "../../components/EnterpriseBand/EnterpriseBand";
import NewsSection from "../../components/NewsSection/NewsSection";
import TestimonialsSection from "../../components/TestimonialsSection/TestimonialsSection";
import ContactSection from "../../components/ContactSection/ContactSection";
import HomeFaqSection from "../../components/HomeFaqSection/HomeFaqSection";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/Navbar";
import {
  heroLines,
  heroLinesMobile,
  heroLinesMobileSm,
  heroLinesServicesMobileSm,
} from "../../assets";
import "./Home.css";

function Home() {
  return (
    // El modal de contratacion rapida lo abren el slide del hero y la seccion
    // de empleados: un unico proveedor para toda la home.
    <HireModalProvider>
      <MainLayout>
        <Navbar />

        <main id="main-content" className="home-content">
          <div className="home__shared-bg-wrapper">
            {/* Decorativa (aria-hidden, blend screen) pero pesa 232KB y sin
                hint de prioridad el navegador la trata como recurso critico:
                compite por ancho de banda con la CSS y la fuente que si
                hacen falta para pintar el H1 -y, al ser grande y estar arriba
                del fold, el propio navegador la toma como candidata a LCP en
                vez del texto real. fetchPriority="low" la saca de esa
                contienda sin dejar de cargarla. width/height preservan aspect ratio y eliminan CLS. */}
            {/* En celular solo se ve una franja de esta imagen (la caja la
                recorta: ver Home.css), asi que a <=768px se sirve ese recorte
                exacto, sin perdida -77 KB contra 231 KB-, y a <=480px se
                recorta ademas lo que ningun ancho de ese rango llega a mostrar
                -27 KB-. Es el elemento que Lighthouse tomaba como LCP en
                mobile. */}
            <picture>
              <source media="(max-width: 480px)" srcSet={heroLinesMobileSm} />
              <source media="(max-width: 768px)" srcSet={heroLinesMobile} />
              <img
                src={heroLines}
                alt=""
                width="981"
                height="5117"
                fetchPriority="low"
                className="home__shared-lines home__shared-lines--hero"
                aria-hidden="true"
              />
            </picture>
            <Hero />
            <IndustryPicker />
          </div>

          {/* La prueba va antes que el catalogo: primero que vean que ya lo
              hicimos, despues como. Es el orden que usa Infosys (su "Top
              Stories" es la seccion siguiente al hero). Casos y testimonios van
              juntos, justo despues del hero: ademas de ser lo que mas convence,
              corta el bloque oscuro de hero + empleados, que sumaba ~3.000px
              negros seguidos. */}
          <FeaturedCases />
          <TestimonialsSection />

          <VirtualEmployeesSection />

          {/* Orden de servicios: IA, e-commerce y software factory. */}
          <div className="home__shared-bg-wrapper">
            {/* Mismo criterio que el de arriba: a <=480px solo se ve una franja,
                y el recorte exacto pesa 40 KB contra 236 KB. */}
            <picture>
              <source media="(max-width: 480px)" srcSet={heroLinesServicesMobileSm} />
              <img
                loading="lazy"
                src={heroLines}
                alt=""
                width="981"
                height="5117"
                className="home__shared-lines home__shared-lines--services"
                aria-hidden="true"
              />
            </picture>
            <AISection />
            <EcommerceSection />
            <SoftwareFactorySection />
            <EnterpriseBand />
            <NewsSection />
            <HomeFaqSection />
            <ContactSection />
          </div>
        </main>

        <Footer />
      </MainLayout>
    </HireModalProvider>
  );
}

export default Home;
